import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { PowerplatformCopilotAuthenticationTypeEnum } from "../enums/enums";

export interface SetCopilotAuthenticationData {
    integrationId: string;
    resourceId: string;
}

export interface SetCopilotAuthenticationDialogResult {
    type: PowerplatformCopilotAuthenticationTypeEnum | null;
}

@Component({
    selector: "app-action-set-copilot-authentication-dialog",
    templateUrl: "./action-set-copilot-authentication-dialog.component.html",
    styleUrls: ["./action-set-copilot-authentication-dialog.component.scss"],
})
export class ActionSetCopilotAuthenticationDialogComponent {
    public selectedOption: PowerplatformCopilotAuthenticationTypeEnum;

    public powerplatformCopilotAuthenticationTypeEnum = PowerplatformCopilotAuthenticationTypeEnum;

    constructor(
        public dialogRef: MatDialogRef<ActionSetCopilotAuthenticationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SetCopilotAuthenticationData,
    ) {}

    public onClose(result: SetCopilotAuthenticationDialogResult = { type: null }) {
        this.dialogRef.close(result);
    }

    public applyClicked() {
        this.onClose({
            type: this.selectedOption,
        } as SetCopilotAuthenticationDialogResult);
    }
}
